import { Button, Grid } from '@mui/material';
import { display } from '@mui/system';
import _ from 'lodash';
import React from 'react';
import { Image } from 'react-bootstrap';
import { useImmer } from 'use-immer';
import ButtonLoading from '../../../../../components/ButtonLoading';
import ButtonUploadImage, { FileT } from '../../../../../components/ButtonUploadImage';
import colors from '../../../../../constants/colors';
import config from '../../../../../constants/config';
import { DisputeT, DisputImageLineItemT } from '../../../../../types/Dispute';
import { JobT } from '../../../../../types/Job';
import { copyObject } from '../../../../../utils';
import { AxiosInstance } from '../../../../../utils/RequestMethods';
import DisputImageLineItem from './DisputImageLineItem';


export interface DisputeImageLineItemT {
    image: string
    notes: string
}

export const DisputeLineItemObject : DisputeImageLineItemT = {
    image: null,
    notes: null
}
export type IDisputeImagesTabProps = {
    job: JobT
    dispute: DisputeT
    onChangeDispute(dispute: DisputeT): void
}

const DisputeImagesTab: React.FC<IDisputeImagesTabProps> = (props) => {
    const [items, setItems] = useImmer<Array<DisputImageLineItemT>>([]);
    React.useEffect(() => {
        console.log("dispute",props?.dispute)
        if (_.isArray(props?.dispute?.images)) {
            setItems(props.dispute.images)
        }
    }, []);


    const [images, setImages] = React.useState<Array<FileT>>([]);

    const addNewItem = () => {
        let cloneItems = _.cloneDeep(items)
        cloneItems.push(_.cloneDeep(DisputeLineItemObject))
        setItems(cloneItems)
        updateDisputeImages(cloneItems)
    }


    const updateLineItem = (index: number, item: DisputImageLineItemT) => {
        let cloneItems = _.cloneDeep(items)
        cloneItems[index] = item
        setItems(cloneItems)
        updateDisputeImages(cloneItems)
    }


    /**
     * 
     * @param index 
     */
    const removeLineItem = (index: number): void => {
        let _cloneItems = _.cloneDeep(items)
        const filteredItems = _cloneItems.slice(0, index).concat(_cloneItems.slice(index + 1, _cloneItems.length))
        // console.log("filteredItems", filteredItems)
        setItems(filteredItems)
        updateDisputeImages(filteredItems)
    }


    const updateDisputeImages = (images: Array<DisputImageLineItemT>) => {
        let disputeCopy: DisputeT = copyObject(props.dispute)
        disputeCopy['images'] = images;
        props.onChangeDispute(disputeCopy)
    }


    const saveImages = async (images: Array<DisputImageLineItemT>): Promise<string> => {
        let disputeCopy: DisputeT = copyObject(props.dispute)
        disputeCopy['images'] = images
        return await AxiosInstance.post(`${config.url.disputes}/${props.job.fkDispute}/save`, disputeCopy).then((res) => {
            return 'Dispute images saved.'
        })
    }


    console.log("items", items)
    return (
        <div className='p-2 mt-4'>
            <Grid container>
                <Grid item xs={10}>
                    <h3>Images</h3>
                </Grid>
                {/* <Grid item>
                    <Button
                        // fullWidth
                        color="success"
                        variant='contained' onClick={() => { addNewItem() }}>
                        Save Images
                    </Button>
                </Grid> */}
            </Grid>
            <div className='d-flex flex-column ' style={{ gap: 5 }}>
                {items.map((item, index) => {
                    return (
                        <div className='' key={`dispute-images-${index}`}>
                            <DisputImageLineItem
                                key={index}
                                item={item}
                                index={index}
                                updateLineItem={updateLineItem}
                                removeLineItem={removeLineItem}
                            />
                        </div>
                    )
                })}
            </div>
            <div className='mt-4 p-2 mx-2' >

                <Button
                    // fullWidth
                    color="info"
                    variant='contained' onClick={() => { addNewItem() }}>
                    <i className='fa fa-plus' />&nbsp;Add Image
                </Button>



            </div>
            <div className='mt-4 p-2 mx-2' >
                <ButtonLoading
                    customButton={Button}
                    // fullWidth
                    customButtonProps={{
                        color: "success",
                        variant: "contained"
                    }}
                    onClickFetching={async (): Promise<string> => {
                        return await saveImages(items)
                    }} >
                    <i className='fa fa-plus' />&nbsp;Save Images
                </ButtonLoading>
            </div>
        </div>
    );
}

export default DisputeImagesTab